import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Question } from 'src/app/models/question.model';
import { QuestionGroupItemDispalyComponent } from './question-group-item-dispaly/question-group-item-dispaly.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AnswersStore } from 'src/app/store/answers-store';
import { filter, map, max, tap } from 'rxjs';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';

@Component({
    selector: 'que-questions-group-display',
    imports: [CommonModule, QuestionGroupItemDispalyComponent, TranslateDirective, TranslatePipe],
    templateUrl: './questions-group-display.component.html',
    styleUrls: ['./questions-group-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionsGroupDisplayComponent implements OnInit {
  @Input()
  question?: Question;
  @Input() isPreview = false;
  @Input() viewAnswer = false;

  #answerStore = inject(AnswersStore);
  #questionnaireStore = inject(QuestionnaireStore);
  rows$ = signal(1);
  isUser$ = toSignal(this.#questionnaireStore.isUser$);
  eventDeleteModularuestionId$ = this.#answerStore.eventDeleteModularuestionId$;

  ngOnInit(): void {
    // this.questionId.set(this.question?.id ?? 0);
    this.#answerStore.answers$.pipe(
      map(arr => arr.filter(x => x.questionId == this.question?.id).map(x => x.modularRowNum).filter(x => x != undefined) as number[]) // Make sure there are answers for the current question
    ).subscribe(filteredArr => {
      if (filteredArr.length > 0) {
        this.rows$.set(Math.max(...filteredArr))
      }
    }
    ).unsubscribe();

    // this.eventDeleteModularuestionId$.pipe(filter(id => id != undefined && id == this.question?.id)).subscribe(
    //   x =>{ this.updateAfterDelete()}
    // )
  }
  delete(order: number) {
    if (this.question?.id) {
      this.#answerStore.deleteAnswerModularGropByOrder({ questionId: this.question?.id, order });
      this.updateAfterDelete();
    }
  }
  updateAfterDelete() {
    this.rows$.set(this.rows$() - 1);
  }
  addModularAnswer() {
    this.rows$.set(this.rows$() + 1)
  }

  // this.answer.valueChanges.subscribe(
  //   ans => {
  //     this.#answerStore.updateAnswer({ id: 0, questionId: this.question?.id ?? 0, base64: ans ?? "", isValid: this.answer.valid })
  //   });

}
